(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduceMotion.matches) return;

  var layers = Array.prototype.slice.call(document.querySelectorAll('[data-plx-layer]'));
  if (!layers.length) return;

  var ticking = false;

  function update() {
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    layers.forEach(function (layer) {
      var rect = layer.getBoundingClientRect();
      var speed = parseFloat(layer.getAttribute('data-plx-speed') || '0');

      if (rect.bottom < 0 || rect.top > viewportHeight) return;

      var progress = (rect.top - viewportHeight * 0.5) / viewportHeight;
      var offset = progress * speed * 120;
      layer.style.transform = 'translate3d(0,' + offset.toFixed(2) + 'px,0)';
    });

    ticking = false;
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  document.addEventListener('shopify:section:load', function () {
    layers = Array.prototype.slice.call(document.querySelectorAll('[data-plx-layer]'));
    requestUpdate();
  });

  requestUpdate();
})();
